import {MediaCardMetadata} from '@wandb/weave/common/types/media';

import {Dimensions} from './types';

export function getGroupedMediaDimensions(
  metadata: MediaCardMetadata | null
): Dimensions | null {
  if (metadata == null) {
    return null;
  }

  const {width, height, grouping} = metadata;
  if (width == null || height == null) {
    return null;
  }

  return {
    width: width * (grouping ?? 1),
    height,
  };
}
